// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Nv4w","vLegacy":"SelectSecondary_vLegacy__2IliN","error":"SelectSecondary_error__njQ33","disabled":"SelectSecondary_disabled__2j13I"};